module.exports = __webpack_public_path__ + "img/authh.7093e75d.png";